export default __webpack_public_path__ + "static/media/sorgo.d2352c00.png";